import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { initializeFirestore, memoryLocalCache } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';
import { getMessaging, isSupported } from 'firebase/messaging';

// Firebase config — these keys are PUBLIC, safe to commit. Real security
// comes from firestore.rules and storage.rules deployed via Firebase CLI.
const firebaseConfig = {
  apiKey: "AIzaSyBSkucLE8ICvTLTP1G3j55Td_fPwwMcDG8",
  authDomain: "aangan-prod.firebaseapp.com",
  projectId: "aangan-prod",
  storageBucket: "aangan-prod.firebasestorage.app",
  messagingSenderId: "606884878810",
  appId: "1:606884878810:web:850949e926908afeda08e3"
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

// Memory-only cache — Firestore data fetched fresh from server each session.
// We switched away from persistentLocalCache because it caused stale snapshots
// to be served from IndexedDB, preventing real-time updates like read-state
// changes from appearing in the UI without a hard refresh.
// Trade-off: no offline support. Acceptable for V1 (users need network anyway).
export const db = initializeFirestore(app, {
  localCache: memoryLocalCache(),
});

export const storage = getStorage(app);
export const functions = getFunctions(app, 'asia-south1');

// Firebase Cloud Messaging — async-init so it doesn't crash on browsers
// that don't support it (some Safari versions, in-app browsers, etc).
// Call `await getMessagingIfSupported()` to safely get the messaging instance.
let _messagingInstance = null;
export async function getMessagingIfSupported() {
  if (_messagingInstance) return _messagingInstance;
  try {
    const supported = await isSupported();
    if (!supported) return null;
    _messagingInstance = getMessaging(app);
    return _messagingInstance;
  } catch (e) {
    console.warn('Firebase Messaging not supported on this browser:', e);
    return null;
  }
}

// Your VAPID public key — used to verify push messages came from your server.
// This is the "Web Push certificate" you generated in Firebase Console.
// Safe to commit (it's a public key — private half stays on Firebase servers).
export const VAPID_KEY = 'BGExcGJSuYhgNPBVEJzNPf7V2yyAtu7SB5fPzrT9dV_TbiT319FdyR_nVbrAmpVK0uaK2xX4QrxT-r4MRYCdyjM';